import { HTMLAttributes } from "react";

export default function Apollo(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2332_2000)">
        <path
          d="M24 1.89153e-05C10.744 1.89153e-05 0 10.746 0 24C0 37.256 10.744 48 24 48C37.254 48 48 37.256 48 24C48.001 21.7379 47.6825 19.487 47.054 17.314C46.9362 17.0279 46.7124 16.7983 46.4293 16.6732C46.1463 16.5482 45.8259 16.5373 45.535 16.6428C45.2441 16.7484 45.0052 16.9623 44.8683 17.2398C44.7313 17.5172 44.7069 17.8369 44.8 18.132H44.796C45.326 20.018 45.6 21.988 45.6 24C45.6078 26.8378 45.0527 29.6489 43.9669 32.2706C42.881 34.8924 41.2859 37.2728 39.274 39.274C37.2728 41.286 34.8925 42.8812 32.2707 43.967C29.6489 45.0529 26.8378 45.6079 24 45.6C21.1623 45.6078 18.3512 45.0527 15.7294 43.9669C13.1076 42.881 10.7272 41.286 8.726 39.274C6.71388 37.2729 5.1187 34.8926 4.03283 32.2708C2.94697 29.649 2.39198 26.8378 2.4 24C2.3922 21.1623 2.94729 18.3512 4.03314 15.7294C5.119 13.1076 6.71406 10.7272 8.726 8.72602C10.7271 6.7139 13.1074 5.11872 15.7293 4.03285C18.3511 2.94698 21.1622 2.392 24 2.40002C29.152 2.40002 34.026 4.19202 37.916 7.48002C37.6701 8.10404 37.6457 8.79349 37.8466 9.43338C38.0476 10.0733 38.4619 10.6249 39.0204 10.9963C39.5789 11.3677 40.2479 11.5363 40.9157 11.4742C41.5835 11.412 42.2098 11.1227 42.6902 10.6547C43.1705 10.1866 43.4759 9.56793 43.5553 8.90194C43.6347 8.23595 43.4834 7.56286 43.1265 6.99495C42.7697 6.42703 42.229 5.99862 41.5945 5.78117C40.96 5.56372 40.2702 5.57037 39.64 5.80002C35.2922 2.05155 29.7406 -0.00719905 24 1.89153e-05ZM21.12 11.76L12.72 33.564H17.98L19.354 29.868H27.292L25.854 25.784H20.628L24.028 16.402L30.076 33.562H35.338L26.94 11.76H21.12Z"
          fill="#112B49"
        />
      </g>
      <defs>
        <clipPath id="clip0_2332_2000">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
